import { baseUrl, twilioToken } from "@/utils";
import axios from "axios";

export const loginApi = async (REQ_BODY: any) => {
  try {
    const body = cleanUndefinedElement(REQ_BODY);
    return await axios.post(`${baseUrl}api/auth`, {
      ...body,
      TWILIO_TOKEN: twilioToken,
    });
  } catch (err) {
    throw err;
  }
};

export const verifyCode = async (REQUEST: any) => {
  try {
    const res = await axios.post(`${baseUrl}api/verify`, REQUEST);
    return res
  } catch (err) {
    throw err;
  }
};

export const resendCodeApi = async (BODY: any) => {
  try {
    return await axios.post(`${baseUrl}api/otp/resend`, {
      ...BODY,
      TWILIO_TOKEN: twilioToken,
    });
  } catch (err) {
    throw err;
  }
};

export const completeProfileApi = async (BODY: any, access_token: string) => {
  try {
    const config = {
      headers: {
        Authorization: `Basic ${access_token}`,
      },
    };
    return await axios.post(`${baseUrl}api/profile/complete`, BODY, config);
  } catch (err) {
    throw err;
  }
};



export function cleanUndefinedElement(data: any) {
  //transform properties into key-values pairs and filter all the empty-values
  const entries = Object.entries(data).filter(([, value]) => value != null);

  //map through all the remaining properties and check if the value is an object.
  //if value is object, use recursion to remove empty properties
  const clean: any = entries.map(([key, v]) => {
    const value = typeof v == 'object' ? cleanUndefinedElement(v) : v;
    return [key, value];
  });

  //transform the key-value pairs back to an object.
  return Object.fromEntries(clean) as any;
}

const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
export const fixNumbers = (str: string) => {
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], `${i}`).replace(arabicNumbers[i], `${i}`)
    }
  }
  // str = str.replace(/\s+/g, '');
  str = str.replace(/[^0-9]+/g, '');
  return str;
}

export const configureAxios = (access_token: string) => {
  const VersionNumber = "v2";
  const appversion = "v3";
  const token = access_token;
  axios.defaults.baseURL = baseUrl;
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  axios.defaults.headers.common.language = "ar";
  axios.defaults.headers.common['accept-language'] = "ar";
  axios.defaults.headers.common.apiversion = VersionNumber;
  axios.defaults.headers.common.appversion = appversion;
}